export default __webpack_public_path__ + "static/media/02.ab962eb2.jpg";